import styled from "styled-components";

import { colors, radii } from "shared/ui/tokens";

export const List = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    /* Позиций в категории бывает под сотню — прокручивается список, а не вся модалка. */
    max-height: 60vh;
    overflow-y: auto;
`;

export const Row = styled.div<{ $dragging: boolean }>`
    display: flex;
    align-items: center;
    gap: 10px;
    min-height: 44px;
    padding: 0 10px;
    border-radius: ${radii.order};
    background: ${({ $dragging }) => ($dragging ? "rgba(25,118,210,0.08)" : "transparent")};
    font-size: 15px;
    color: ${colors.textPrimary};

    svg {
        flex: none;
        font-size: 18px;
        color: rgba(0, 0, 0, 0.38);
    }
`;

export const Name = styled.span`
    flex: 1 1 auto;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export const Empty = styled.p`
    margin: 0;
    color: ${colors.textSecondary};
`;
